import { createFileRoute } from '@tanstack/react-router';

import { LandingBold } from '#features/landing/components/LandingBold';

/**
 * Смелый вариант первого экрана лендинга. Временный экран рядом с другими превью:
 * прод-лендинг не трогает, удаляется вместе с компонентом.
 *
 * `ssr: false`: герой держится на WebGL и замерах курсора, серверный рендер ему не нужен.
 */
export const Route = createFileRoute('/{-$locale}/_layout/preview/landing-bold')({
  component: LandingBold,
  ssr: false,
});
